export const SiteConsts = {
  SITE_NAME: "Nagavret",
  FONT_KEY_GLOBAL_1: "DayRomanRegular",
  FONT_KEY_GLOBAL_2: "CormorantRegular",
  DONATE_HREF: "https://www.buymeacoffee.com/alvrineom",
};
